import React, {useEffect, useState} from 'react';

import {Button} from '@kit';

import {LastRead, readLastRead} from '../../lib/last-read';
import {Link} from '../../lib/routes';

import css from './continue-reading.module.css';

export const ContinueReading: React.FC = () => {
	const [last, setLast] = useState<LastRead | null>(null);
	useEffect(() => setLast(readLastRead()), []);
	if (!last) return null;

	return (
		<section className={css.block} aria-labelledby="home-continue">
			<div className={css.text}>
				<h2 id="home-continue" className={css.title}>
					Продолжить чтение
				</h2>
				<Link route="bookChapter" params={{bookId: last.bookId, chapterId: last.chapterId}} className={css.chapter}>
					{last.bookTitle}: {last.chapterTitle}
				</Link>
			</div>
			<Button appearance="primary" route="bookChapter" routeParams={{bookId: last.bookId, chapterId: last.chapterId}}>
				Читать дальше
			</Button>
		</section>
	);
};
